export enum SnackVariantes {
  Default = 'default',
  Error = 'error',
}
